import React from "react";

import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";

import {apollo_useStyles} from "../atom/Apollo_styles";

export const ApolloButton: React.FC<{ handleButton: () => void, button?: string, title?: string, text?: string, disabled?: boolean }> = (props) => {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const classes = apollo_useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  const title = props.title ? props.title : "未設定";
  const button = props.button ? props.button : "未設定";
  const text = props.text ? props.text : title + "しますか？";
  const disabled = props.disabled ? props.disabled : false;

  return (
    <React.Fragment>
      <Button className={classes.buttonTop} variant="contained" color="primary" onClick={handleClickOpen} disabled={disabled}>
        {button}
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            キャンセル
          </Button>
          <Button
            onClick={() => {
              handleClose();
              props.handleButton();
            }}
            color="primary"
            autoFocus
          >
            {button}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

export const ApolloButtonBaseDelete: React.FC<{ handleButton: () => void, button?: string, title?: string, text?: string, disabled?: boolean }> = (props) => {
  const title = props.title ? props.title : "未設定";
  const button = props.button ? props.button : "未設定";
  const text = props.text ? props.text : title + "しますか？";
  const disabled = props.disabled ? props.disabled : false;

  const classes = apollo_useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button className={classes.button} variant="contained" color="secondary" onClick={handleClickOpen} disabled={disabled}>
        {button}
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            キャンセル
          </Button>
          <Button
            onClick={() => {
              handleClose();
              props.handleButton();
            }}
            color="secondary"
            autoFocus
          >
            {button}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}